import React from "react";
import { useAuth } from "../AuthContext";
import useBlockedUsers from "../hooks/useBlockedUsers";
import ReportButton from "./ReportButton";

/**
 * Report + Block/Unblock for a person (public profile, message thread). Block needs sign-in
 * and isn't offered on yourself. reportType/reportId default to the person's profile.
 */
export default function UserSafetyActions({ userId, name, reportType = "PROFILE", reportId, reportTitle }) {
  const { user } = useAuth();
  const { isBlocked, block, unblock } = useBlockedUsers();
  if (!userId || (user && Number(user.userId) === Number(userId))) return null;
  const blocked = isBlocked(userId);

  const toggle = async () => {
    if (blocked) {
      try { await unblock(userId); } catch { /* ignore */ }
      return;
    }
    // eslint-disable-next-line no-alert
    if (!window.confirm(`Block ${name || "this person"}? You won't see their comments or content, and neither of you can message the other. You can unblock them any time.`)) return;
    try { await block(userId); } catch { /* ignore */ }
  };

  return (
    <span className="comment-actions">
      <ReportButton targetType={reportType} targetId={reportId ?? userId} targetUserId={userId}
        targetTitle={reportTitle || name} />
      {user && (
        <button type="button" className="report-btn" onClick={toggle}>{blocked ? "Unblock" : "Block"}</button>
      )}
    </span>
  );
}
